jQuery(document).ready(function($) {
  $('.client-logo-slider ul').slick({
      dots: false,
     arrows: false,
      slidesToShow: 6,
      slidesToScroll: 6,
     //  autoplay: true,
      autoplaySpeed: 2000,

      responsive: [
          {
          breakpoint: 1281,
          settings: {
          slidesToShow: 5,
          slidesToScroll: 5
           }
      },
      {
        breakpoint: 981,
        settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
         }
    },
          
          {
  
            breakpoint: 551,
    
            settings: {
    
              slidesToShow: 3,
              slidesToScroll: 1
    
            }
  
        }, {
  
            breakpoint: 481,
    
            settings: {
    
              slidesToShow: 2,
              slidesToScroll: 1
    
            }
  
        }
  
      ]
     
}); 
});


  